class FetchPasswordReset {
	constructor(public readonly token: string) {
		Object.freeze(this);
	}
}

export default FetchPasswordReset;
